<script setup lang="ts">
import { useKeycloak } from '@solfacil/plasma-utils';

const error = useError();
const loading = ref(true);
setTimeout(() => {
  loading.value = false;
}, 3000);

const handleError = () => {
  location.reload();
};

const isUnauthorized = error.value?.statusCode === 401;
const logout = () => {
  useKeycloak().logout();
};
</script>

<template>
  <div class="error-container">
    <SharedCircleLoader v-if="loading" />
    <div v-else class="error-container">
      <SolEmptyState
        v-if="isUnauthorized"
        id="partner-unauthorized"
        variant="no-content"
        class="empty-state"
        title="Não foi possível acessar a página"
        :subtitle="error?.message || 'Ocorreu um erro ao recuperar algumas informações. Por favor, tente novamente.'"
      />
      <SolEmptyState
        v-else
        id="partner-not-found"
        variant="error404"
        class="empty-state"
        title="Não foi possível carregar a página"
        :subtitle="error?.message || 'Ocorreu um erro ao recuperar algumas informações. Por favor, tente novamente.'"
      />
      <SolButton v-if="isUnauthorized" id="button-not-found" class="mt-6" @click="logout">
        Fazer logout
      </SolButton>
      <SolButton v-else id="button-not-found" class="mt-6" @click="handleError">
        Tentar novamente
      </SolButton>
    </div>
  </div>
</template>

<style lang="css">
.error-container {
  @apply flex flex-col justify-center items-center;
  height: 100vh;
}

</style>
